module.exports = __webpack_public_path__ + "static/media/marker-inactive.9453bc84.svg";